import { render, staticRenderFns } from "./kpi-managers-pay.vue?vue&type=template&id=32689a77"
import script from "./kpi-managers-pay.vue?vue&type=script&lang=js"
export * from "./kpi-managers-pay.vue?vue&type=script&lang=js"
import style0 from "./kpi-managers-pay.vue?vue&type=style&index=0&id=32689a77&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports